// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2-kxU","text":"SelectPayment_text__-EgeU","title":"SelectPayment_title__2hX9d","btn":"SelectPayment_btn__1PF8E"};